import React from 'react';
import {Button} from '@material-ui/core';
import styles from "./AbstractButton.module.scss";
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IAbstractButtonProps {
  className?: string;
  label?: any;
  children?: any;
  isSubmitting?: boolean;
  setSubmitRef?: any;
  onClick?: any;
  loading?: boolean;
}

const AbstractButton = (props: IAbstractButtonProps) => (props.loading ?
  <SkeletonPlaceHolder
    className={`${styles.AbstractButton}
    ${props.className}`.trim()}
    height={48}/> : <Button
    className={`${styles.AbstractButton} ${props.className}`.trim()}
    variant="contained"
    color="primary"
    disabled={props.isSubmitting}
    onClick={props.onClick}
    ref={props.setSubmitRef}
  >
    {props.label}
    {props.children}
  </Button>);

AbstractButton.defaultProps = {
  className: '',
  label: '',
  isSubmitting: false,
};

export default React.memo(AbstractButton);
